








































import Vue from 'vue'
import { apps } from '@rhitics/rhitics/config'
import { AppConfig } from '@rhitics/rhitics/config'

export default Vue.extend({
  name: 'AppMenu',

  computed: {
    apps() {
      return Object.values(apps).map((app: AppConfig) => {
        const { prefix } = app

        const url = prefix === ''
          ? `https://${process.env.VUE_APP_WEBSITE_DOMAIN}`
          : `https://${prefix}.${process.env.VUE_APP_WEBSITE_DOMAIN}`

        return {
          ...app,
          url,
          isAccessible: !app.policy || this.$auth.can(app.policy)
        }
      })
    }
  }
})
